module.exports = __webpack_public_path__ + "media/images/front/varieties/SANDO-4c104203958403e60ba49e6cd48a67a7.jpg";